import { Graph_Name, Graphs, NOT_AVAILABLE } from "../../../utils/constants/insightsConstants";
import { USER_TYPE } from "../../../utils/constants/userConstants";
import * as Constants from "./constants";
import moment from 'moment';
import * as XLSX from 'xlsx';

const formatXAxisDate=(value,timegranularity)=>{
    let _xAxis="";
    if(timegranularity==Constants.MINUTE15 || timegranularity==Constants.MINUTE5){
        _xAxis=moment(value).format("MMM DD, h:mm A");
    }
    if(timegranularity==Constants.HOUR){
        _xAxis=moment(value).format("MMM DD, h A");
    }
    if(timegranularity==Constants.DAY){
        _xAxis=moment(value).format("MMM DD");
    }
    if(timegranularity==Constants.MONTH){
        _xAxis=moment(value).format("YYYY MMM");
    }
    return _xAxis;
}
export const getUniqueValues=(obj,key)=>{
    let unique = [...new Set(obj.map(item => item[key]))];
    return sortArray(unique);
}

export const processInOutData=(data,legendData,timegranularity)=>{
    let result={};
    let total_in_messages_array = [];
    let total_out_messages_array = [];
    let total_messages_array = [];
    let xAxis_array = [];  
    let totalCount = 0; 
    data.forEach((value, index, array) => {
        total_in_messages_array.push(value?.total_in_messages);
        total_out_messages_array.push(value?.total_out_messages);
        total_messages_array.push(value?.total_messages);
        let _value= typeof value?.timeX == 'object' ? value?.timeX?.value:value?.timeX // for granularity minute and hour type is object and for day and month type is string
        let _xAxis=formatXAxisDate(_value,timegranularity);
        xAxis_array.push(_xAxis);
    });    
    totalCount = (total_in_messages_array.length) + (total_out_messages_array.length) + (total_messages_array.length)

    let series = [
        {
            name: legendData[0],
            type: 'line',
            //connectNulls: true, 
            // stack: 'Total',
            data: total_in_messages_array
        },
        {
            name: legendData[1],
            type: 'line',
            //connectNulls: true, 
            // stack: 'Total',
            data: total_out_messages_array
        },
        {
            name: legendData[2],
            type: 'line',
            //connectNulls: true, 
            // stack: 'Total',
            data: total_messages_array
        },        
    ]
    result.xAxis_array=xAxis_array;
    result.series=series;
    result.totalCount=totalCount;
    return result;
}


export const processInOutDataByNode=(data,timegranularity,graphType)=>{
        let finalObject={};
        let legendData=[];
        let xAxisData=[]
        let seriesData=[];
        data.forEach((item) => {
            let _value= typeof item?.timeX == 'object' ? item?.timeX?.value:item?.timeX // for granularity minute and hour type is object and for day and month type is string
            xAxisData.push(_value);
        })
        let unique_xAxisData = [...new Set(xAxisData)];
        let _unique_xAxisData=[];
        unique_xAxisData.forEach((value=>{
           let _xAxis=formatXAxisDate(value,timegranularity);
            _unique_xAxisData.push(_xAxis);
        }))
        let objectByNode=Object.groupBy(data, ({ vrs_signalling_nodes }) => vrs_signalling_nodes);
        Object.keys(objectByNode).forEach((key) => {
            let total_in_key,total_out_key;
            if(graphType==Graphs.DIAMETER){
                 total_in_key=key+"-"+Constants.IN_MESSAGE;
                 total_out_key=key+"-"+Constants.OUT_MESSAGE;
            }else {
                 total_in_key=key+"-"+Constants.IN_MSUs;
                 total_out_key=key+"-"+Constants.OUT_MSUs;
            }
            legendData.push(total_in_key);
            legendData.push(total_out_key);
            finalObject[total_in_key]=[];
            finalObject[total_out_key]=[];
        
            objectByNode[key].forEach((item) => {
                finalObject[total_out_key].push(item.total_out_messages);
                finalObject[total_in_key].push(item.total_in_messages);
            });
            // unique_xAxisData.forEach(ts=>{  // CUP-2451 code reverted due to CUP-2620
            //     const obj = objectByNode[key].find(item =>{
            //         let _value= typeof item?.timeX == 'object' ? item?.timeX?.value:item?.timeX // for granularity minute and hour type is object and for day and month type is string
            //         return _value == ts
            //     }
            //     );
            //     if (obj) {
            //         finalObject[total_out_key].push(obj.total_out_messages);
            //         finalObject[total_in_key].push(obj.total_in_messages);
            //     } else {
            //         finalObject[total_out_key].push(null);
            //         finalObject[total_in_key].push(null);
            //     }
            // })
         });

         Object.keys(finalObject).forEach((key) => {
            seriesData.push({
                name: key,
                type: 'line',
                //connectNulls: true, 
                // stack: 'Total',
                data: finalObject[key]
            })
         });
        let result={};
        result.xAxisData=_unique_xAxisData;
        result.legendData=legendData;
        result.seriesData=seriesData;
        return  result;
}  

export const processPeakInOutData=(data,timegranularity)=>{
    let finalObject={};
    let legendData=[];
    let xAxisData=[]
    let seriesData=[];
    data.forEach((item) => {
        xAxisData.push(item.report_date?.value+"T"+item?.hour.toString().padStart(2, "0")+":00:00");
    })
    let unique_xAxisData = [...new Set(xAxisData)];
    let _unique_xAxisData=[];
    unique_xAxisData.forEach((value=>{
        let _xAxis=formatXAxisDate(value,timegranularity);
        _unique_xAxisData.push(_xAxis);
    }))
    let objectByRouter=Object.groupBy(data, ({ target }) => target);
    Object.keys(objectByRouter).forEach((key) => {
        let max_peak_in_key=Constants.MAX_PEAK_IN+"-"+key;
        let max_peak_out_key=Constants.MAX_PEAK_OUT+"-"+key;
        legendData.push(max_peak_in_key);
        legendData.push(max_peak_out_key);
        finalObject[max_peak_in_key]=[];
        finalObject[max_peak_out_key]=[];
        objectByRouter[key].forEach((item) => {
            finalObject[max_peak_in_key].push(item.peak_in);
            finalObject[max_peak_out_key].push(item.peak_out);
        });
        // unique_xAxisData.forEach(ts=>{  //CUP-2451 code reverted due to CUP-2620
        //     const [date, time] = ts.split("T");
        //     const hour = Number(time.substring(0, 2));
        //     const obj = objectByRouter[key].find(item =>
        //         item?.report_date?.value === date && Number(item?.hour) === hour
        //     );
        //     if (obj) {
        //         finalObject[max_peak_in_key].push(obj.peak_in);
        //         finalObject[max_peak_out_key].push(obj.peak_out);
        //     } else {
        //         finalObject[max_peak_in_key].push(null);
        //         finalObject[max_peak_out_key].push(null);
        //     }
        // })
     });


     Object.keys(finalObject).forEach((key) => {
        seriesData.push({
            name: key,
            type: 'line',
            //connectNulls: true, 
            // stack: 'Total',
            data: finalObject[key]
        })
     });
    let result={};
    result.xAxisData=_unique_xAxisData;
    result.legendData=legendData;
    result.seriesData=seriesData;
    return  result;
} 

export const processVolumeInOutData=(data,timegranularity)=>{
    let finalObject={};
    let legendData=[];
    let xAxisData=[]
    let seriesData=[];
    data.forEach((item) => {
        xAxisData.push(item.report_date?.value+"T"+item?.hour.toString().padStart(2, "0")+":00:00");
    })
    let unique_xAxisData = [...new Set(xAxisData)];
    let _unique_xAxisData=[];
    unique_xAxisData.forEach((value=>{
        let _xAxis=formatXAxisDate(value,timegranularity);
        _unique_xAxisData.push(_xAxis);
    }))
    let objectByRouter=Object.groupBy(data, ({ target }) => target);
    Object.keys(objectByRouter).forEach((key) => {
        let max_volume_in_key=Constants.MAX_VOLUME_IN+"-"+key;
        let max_volume_out_key=Constants.MAX_VOLUME_OUT+"-"+key;
        legendData.push(max_volume_in_key);
        legendData.push(max_volume_out_key);
        finalObject[max_volume_in_key]=[];
        finalObject[max_volume_out_key]=[];
        objectByRouter[key].forEach((item) => {
            finalObject[max_volume_in_key].push(item.volume_in);
            finalObject[max_volume_out_key].push(item.volume_out);
        });
        // unique_xAxisData.forEach(ts=>{  //CUP-2451 code reverted due to CUP-2620
        //     const [date, time] = ts.split("T");
        //     const hour = Number(time.substring(0, 2));
        //     const obj = objectByRouter[key].find(item =>
        //         item?.report_date?.value === date && Number(item?.hour) === hour
        //     );
        //     if (obj) {
        //         finalObject[max_volume_in_key].push(obj.volume_in);
        //         finalObject[max_volume_out_key].push(obj.volume_out);
        //     } else {
        //         finalObject[max_volume_in_key].push(null);
        //         finalObject[max_volume_out_key].push(null);
        //     }
        // })
     });


     Object.keys(finalObject).forEach((key) => {
        seriesData.push({
            name: key,
            type: 'line',
            //connectNulls: true, 
            // stack: 'Total',
            data: finalObject[key]
        })
     });
    let result={};
    result.xAxisData=_unique_xAxisData;
    result.legendData=legendData;
    result.seriesData=seriesData;
    return  result;
} 

export const sortArray =(array)=>{
    const newArray=JSON.parse(JSON.stringify(array)); // No change in original array
    return newArray.sort((a,b)=>a?.toUpperCase().localeCompare(b?.toUpperCase()));  // Ascending alphabetical
}

export const exportChartDataToExcel = (xAxisData, series, selectedKeys, selectedFiletrs = {}, graphName = 'chart_data', grpahType,userType,XAxisName='') => {

const filteredSeries = series?.filter(s => selectedKeys[s.name]);

    let allowedFilters = [];
    let filterLabelMap = {};

    if (graphName === Graph_Name.Peak_In_Out || graphName === Graph_Name.Volume_In_Out) {
        allowedFilters = ['cp_names', 'service_types', 'time_window'];
        filterLabelMap = {
            cp_names: userType === USER_TYPE.CUSTOMER ? 'Region' : 'TADIG Code',
            service_types: 'Service Type',
            time_window: 'Time Window'
        };
    } else if (userType === USER_TYPE.CUSTOMER) {
        if (graphName === Graph_Name.In_Out_MSU || graphName === Graph_Name.In_Out_Message) {
            allowedFilters = ['time_granularity', 'time_window'];
            filterLabelMap = {
                time_granularity: 'Time Granularity',
                time_window: 'Time Window'
            };
        } else {
            allowedFilters = ['time_granularity', 'time_window', 'signalling_node', 'connection_id'];
            filterLabelMap = {
                time_granularity: 'Time Granularity',
                time_window: 'Time Window',
                signalling_node: 'Signalling Node',
                connection_id: 'Connection Id'
            };
        }
    } else {
        allowedFilters = ['time_granularity', 'time_window', 'final_type', 'final_destination'];
        filterLabelMap = {
            time_granularity: 'Time Granularity',
            time_window: 'Time Window',
            final_type: 'Final Type',
            final_destination: 'Final Destination'
        };
    }

      const filterRows = allowedFilters
      .filter(key => key in selectedFiletrs)
      .map(key => ({
          Filter: filterLabelMap[key] || key,
          Value: key === "service_types"?(selectedFiletrs[key] ?? '')?.toUpperCase():(selectedFiletrs[key] ?? '')
      }));

    const formatNumberWithUnits = (number) => {
        let units = [];
        if (graphName == Graph_Name.Peak_In_Out) {
            units = ['bps', 'Kbps', 'Mbps', 'Gbps', 'Tbps'];
        } else {
            units = ['KB', 'MB', 'GB', 'TB'];
        }

        let i = 0;
        while (number >= 1000 && i < units.length - 1) {
            number /= 1000;
            i++;
        }
        return number.toFixed(2) + ' ' + units[i]
    }

    const chartDataRows = xAxisData?.map((timestamp, index) => {
        const timeLabel=`Timestamp ${XAxisName}`
        const row = { [timeLabel] : String(timestamp) };
        filteredSeries?.forEach((s) => {
            let value = s.data?.[index] ?? '';
            if (grpahType === Graphs.WEATHERMAPS) {
                value = formatNumberWithUnits(value);
            }
            row[s.name] = String(value);
        });
        return row;
    });

    const worksheet = XLSX.utils.aoa_to_sheet([]);

    XLSX.utils.sheet_add_json(worksheet, filterRows, { origin: 'A1', skipHeader: true });

    const spacingRowIndex = filterRows?.length + 2;
    XLSX.utils.sheet_add_aoa(worksheet, [[]], { origin: `A${spacingRowIndex}` });

    XLSX.utils.sheet_add_json(worksheet, chartDataRows, { origin: `A${spacingRowIndex + 1}` });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, graphName);

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const now = new Date();
    const formattedDateTime = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}_${String(now.getHours()).padStart(2, '0')}-${String(now.getMinutes()).padStart(2, '0')}`;

    const resolvedFileNameMap = {
        Peak_In_Out: `IPLinkUtilization_Peak_In_Out_${formattedDateTime}`,
        Volume_In_Out: `IPLinkUtilization_Volume_In_Out_${formattedDateTime}`,
        In_Out_Message: `Diameter_In_Out_Message_${formattedDateTime}`,
        In_Out_Message_By_SigNode: `Diameter_In_Out_Message_By_SigNode_${formattedDateTime}`,
        In_Out_MSU: `Sigtran_In_Out_MSU_${formattedDateTime}`,
        In_Out_MSU_By_SigNode: `Sigtran_In_Out_MSU_By_SigNode_${formattedDateTime}`,
    };

    const fileName = resolvedFileNameMap[graphName] || `Export_${formattedDateTime}`;
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = `${fileName}.xlsx`;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(url);
};

export const updateInsightURL = (params, navigate, tabKey, filterKey, filter, remove = false) => {
    let existingFilters = {};
    if (params?.data) {
      try {
        existingFilters = JSON.parse(decodeURIComponent(params.data));
      } catch {
        console.warn("Failed to parse existing filter data");
      }
    }
    const combined = { ...existingFilters };
    if (remove) {
      delete combined[filterKey];
    } else {
      combined[filterKey] = { tab: tabKey, ...filter };
    }
    const encoded = encodeURIComponent(JSON.stringify(combined));
    navigate(`/insights/${tabKey.toLowerCase()}/${encoded}`);
  };